import { CellProps } from 'react-table';
import { ToursTableRow } from '../common/types/types';
import { TourStatusCellProps } from '../common/types/tours-table-row';
import { FC } from 'react';
import { TourStatus } from 'components/atoms/TourStatus/TourStatus';

export const TourStatusCell: FC<CellProps<ToursTableRow, TourStatusCellProps>> = ({ value: { tourStatus } }) => {
  return <TourStatus tourStatus={tourStatus} />;
};
